import React, { createContext, useContext, useState } from 'react';

const AreaContext = createContext();

export function AreaProvider({ children }) {
  // 'central' | 'vitalidade' | 'mentalidade' | 'prosperidade'
  const [activeArea, setActiveArea] = useState('central');

  const value = {
    activeArea,
    setActiveArea,
  };

  return (
    <AreaContext.Provider value={value}>
      {children}
    </AreaContext.Provider>
  );
}

export function useArea() {
  return useContext(AreaContext);
}

